import React from "react";
import _ from "lodash";

const AvailableTimeslots = ({ availability }) => {
  if (_.isNull(availability)) return <div>Please select a practitioner and an available date from calendar.</div>;
  return (
    <div>
      <div>
        {availability.full_date} - {availability.timezone}
      </div>
      {availability.timeslots.map((ts, idx) => (
        <div key={idx}>
          {ts.start} - {ts.end}
        </div>
      ))}
    </div>
  );
};

export default AvailableTimeslots;
